export const PlanOverviewModalConfigInput = [
  {
    label: "Workout Name",
    type: "text",
    id: "workoutname",
    valueKey: "planName",
    disabled: true,
  },
  {
    label: "Duration",
    type: "text",
    id: "Duration",
    valueKey: "duration",
    disabled: true,
  },
  {
    label: "Level",
    type: "select",
    id: "Level",
    options: ["Beginner", "Intermediate", "Advanced"],
    valueKey: "level",
    disabled: true,
  },
  {
    label: "Location",
    type: "select",
    id: "Location",
    options: ["Gym", "Home", "Outdoor"],
    valueKey: "location",
    disabled: true,
  },
  {
    label: "Category",
    type: "select",
    id: "Category",
    options: ["Strength", "Cardio", "Flexibility"],
    valueKey: "training_type",
    disabled: true,
  },
  {
    label: "Description",
    type: "textarea",
    id: "description",
    valueKey: "description",
    rows: 4,
    disabled: true,
  },
  {
    label: "Banner Image URL",
    type: "text",
    id: "bannerImageUrl",
    valueKey: "banner_image",
  },
  {
    label: "Video URL",
    type: "text",
    id: "videoUrl",
    valueKey: "plan_video",
  },
];